import {
  bulkUpdateNotificationStatusByFilter,
  countViewerFeedNotifications,
  queryViewerFeedNotifications,
} from '@wix/ambassador-notifications-members-feed-v1-members-viewer-feed-notification/http';
import {
  Channel,
  SortOrder,
  Status,
} from '@wix/ambassador-notifications-members-feed-v1-members-viewer-feed-notification/types';
import type { OOIControllerFlowAPI } from '@wix/yoshi-flow-editor-runtime/build/cjs/flow-api/OOIController';
import { getDummyNotifications, shouldGetDummyData } from './dummy-data';

export const markAsRead = (flowAPI: OOIControllerFlowAPI, id: string) => {
  return flowAPI.errorHandler
    .withErrorHandler(
      () =>
        flowAPI.httpClient.request(
          bulkUpdateNotificationStatusByFilter({
            filter: {
              id: { $in: [id] },
            },
            status: Status.READ,
          }),
        ),
      { errorCodesMap: {} },
    )
    .catch((e) => {
      throw flowAPI.errorHandler.getResolvedError(e);
    });
};

export const markAllAsRead = (flowAPI: OOIControllerFlowAPI) => {
  return flowAPI.errorHandler
    .withErrorHandler(
      () =>
        flowAPI.httpClient.request(
          bulkUpdateNotificationStatusByFilter({
            filter: {
              channel: Channel.WEB,
              status: { $in: [Status.UNSEEN, Status.SEEN_BUT_UNREAD] },
              sentDate: { $lte: new Date() },
            },
            status: Status.READ,
          }),
        ),
      { errorCodesMap: {} },
    )
    .catch((e) => {
      throw flowAPI.errorHandler.getResolvedError(e);
    });
};

export const getUnseenCount = async (flowAPI: OOIControllerFlowAPI) => {
  if (shouldGetDummyData(flowAPI)) {
    return 2;
  }
  const { data } = await flowAPI.errorHandler
    .withErrorHandler(
      () =>
        flowAPI.httpClient.request(
          countViewerFeedNotifications({
            filter: {
              channel: Channel.WEB,
              status: Status.UNSEEN,
            },
            maxCount: 100,
          }),
        ),
      { errorCodesMap: {} },
    )
    .catch((e) => {
      flowAPI.errorHandler.getResolvedError(e);
      return { data: { count: 0 } };
    });
  return data.count;
};

export const getNotifications = async (
  flowAPI: OOIControllerFlowAPI,
  cursor?: string,
) => {
  if (shouldGetDummyData(flowAPI)) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return getDummyNotifications(flowAPI);
  }
  const { data } = await flowAPI.errorHandler
    .withErrorHandler(
      () =>
        flowAPI.httpClient.request(
          queryViewerFeedNotifications({
            language: flowAPI.environment.language,
            query: {
              filter: cursor
                ? undefined
                : {
                    channel: Channel.WEB,
                  },
              sort: cursor
                ? undefined
                : [
                    {
                      fieldName: 'sentDate',
                      order: SortOrder.DESC,
                    },
                  ],
              cursorPaging: {
                limit: 50,
                cursor,
              },
            },
          }),
        ),
      { errorCodesMap: {} },
    )
    .catch((e) => {
      throw flowAPI.errorHandler.getResolvedError(e);
    });
  return data;
};
